<template> 
    <BaseModal
        :id="'static'"
        :title="title"
        :size="'lg'"
    >
        <template v-slot:breadcrumb>
            <Breadcrumb :breadcrumb="breadcrumb"/>
        </template>
        <template v-slot:content>
            <form class="col-12 p-0" @submit.prevent="form_submit_local()">
                <div class="row">
                    <div class="col-md-12" style="max-height: 60vh; overflow-y: auto;">
                        <table class="table">
                            <thead style="background-color: #f1f1f1;">
                                <tr>
                                    <th>
                                        <span class="custom-control custom-checkbox">
                                            <input :id="`checkedMainFM`" type="checkbox" class="custom-control-input" @change="selectAll($event, 'items')"/>
                                            <label :for="`checkedMainFM`" class="custom-control-label ml-2"/>
                                        </span>
                                    </th>
                                    <th scope="col" v-html="'Name'"/>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, i) in array_options.master_step_code_id" :key="i">
                                    <td>
                                        <span class="custom-control custom-checkbox">
                                            <input :id="`checkedFM${i}`" type="checkbox" class="custom-control-input" v-model="item.checked" :disabled="template_items.find(template_item => template_item.master_step_code_id == item.id)"/>
                                            <label :for="`checkedFM${i}`" class="custom-control-label ml-2"/>
                                        </span>
                                    </td>
                                    <td v-html="item.name" :style="template_items.find(template_item => template_item.master_step_code_id == item.id) ? `color: rgb(131 134 136)` : ''"/>
                                </tr>
                            </tbody>
                        </table>
                            
                        </div>
                    </div>
                
                <CentralButtons />
            </form>
        </template>
    </BaseModal>
</template>

<script>

import FormResources    from    './form_resources'
import Resources        from    './detail_resources'
import Breadcrumb       from    '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal        from    '@/components/BaseModal'
import CentralButtons   from    '@/components/CentralButtons'

export default {

    name:   'FormModal',
    props: [
        "title",
        "parent_id",
        "rest_api",
        "notyf",
        "array_options",
        "breadcrumb",
        "template_items"
    ],

    components: {
        Breadcrumb,
        BaseModal,
        CentralButtons,
    },

    data(){
        return {
            form_data:      FormResources.form_data,
            form_format:    FormResources.form_format,
            form_backup:    {...FormResources.form_data},
            step_table_headers: Resources.step_table_headers,
            search:         '',
        }
    },

    methods: {
        selectAll(event, section)
        {
            let is_checked = event.target.checked

            if(section == 'items')
            {
                this.array_options.master_step_code_id.map(item => {
                    if(this.template_items.find(template_item => template_item.master_step_code_id == item.id))
                    {
                        item.checked = false
                    }
                    else
                    {
                        item.checked = is_checked
                    }
                })
            }
            else
            {
                this.form_data.master_step_code_id.map(item => item.checked = is_checked)
            }

        },

        async form_submit_local()
        {

            const selected_items = this.array_options.master_step_code_id.filter(item => item.checked)

            this.form_data.master_step_code_id = selected_items.map(obj => obj.id);

            await this.form_submit();

            return true;
        },
    },
    watch: {
        parent_id(val) 
        {
            this.form_data.inspection_template_id = val
            this.form_backup.inspection_template_id = val
        }
    },

    mounted() {

    },
}
</script>